import React from "react"
import Item from "./Item"
import { getMapKey, getPaddingsClassFromData } from "@/utils/utils"
import GridContainer from "@/components/common/GridContainer"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

export default function GridVariant({ data }) {
	const paddings = getPaddingsClassFromData(data)
	const partners = data?.partners || []

	return (
		<section className={paddings}>
			<HeaderDescriptionBlock headerDescription={data?.headerDescription || null} />
			<GridContainer>
				{partners.map((partner, index) => (
					<Item key={getMapKey(partner, index)} data={partner} className="col-desktop-4 col-mobile-8" />
				))}
			</GridContainer>
		</section>
	)
}
